// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4d-6";
export var headerCell = "_4d-2";
export var rowWrapper = "_4d-4";
export var stickyAggregationCell = "_4d-a";
export var stickyAggregationRow = "_4d-7";
export var stickyColumnCell = "_4d-9";
export var stickyColumnHeaderCell = "_4d-8";
export var table = "_4d-1";
export var virtualRowWrapper = "_4d-5";
export var virtualTableContainer = "_4d-0";
export var white = "_4d-3";